export default {
  bind(el, binding) {
    const options = binding.value || {};
    const content = options.content || '';
    const position = options.position || 'top';
    const theme = options.theme || 'dark';
    const trigger = options.trigger || 'hover';
    const delay = options.delay || 0;
    const hideDelay = options.hideDelay || 0;
    const offset = options.offset || 8;
    const animation = options.animation || 'fade';

    const tooltip = document.createElement('div');
    tooltip.className = `tooltip-content tooltip-${position} tooltip-theme-${theme}`;
    tooltip.style.position = 'absolute';
    tooltip.style.zIndex = 9999;
    tooltip.style.opacity = 0;
    tooltip.innerHTML = `
        ${content}
        <div class="tooltip-arrow tooltip-arrow-${position} tooltip-arrow-theme-${theme}"></div>
    `;
    //tooltip.innerText = content;
    document.body.appendChild(tooltip);

    const show = () => {
      document.body.appendChild(tooltip);

        // Espera un tick para que se pinte y tenga tamaño
        requestAnimationFrame(() => {
            const rect = el.getBoundingClientRect();

            let top = 0, left = 0;

            switch (position) {
            case 'top':
                top = rect.top - tooltip.offsetHeight - offset;
                left = rect.left + rect.width / 2 - tooltip.offsetWidth / 2;
                break;
            case 'bottom':
                top = rect.bottom + offset;
                left = rect.left + rect.width / 2 - tooltip.offsetWidth / 2;
                break;
            case 'left':
                top = rect.top + rect.height / 2 - tooltip.offsetHeight / 2;
                left = rect.left - tooltip.offsetWidth - offset;
                break;
            case 'right':
                top = rect.top + rect.height / 2 - tooltip.offsetHeight / 2;
                left = rect.right + offset;
                break;
            }

            tooltip.style.top = `${top}px`;
            tooltip.style.left = `${left}px`;
            tooltip.style.opacity = 1;
        });
    };

    const hide = () => {
      tooltip.style.opacity = 0;
    };

    const showHandler = () => {
      if (delay > 0) {
        el._tooltipTimer = setTimeout(show, delay);
      } else {
        show();
      }
    };

    const hideHandler = () => {
      clearTimeout(el._tooltipTimer);
      if (hideDelay > 0) {
        el._tooltipTimer = setTimeout(hide, hideDelay);
      } else {
        hide();
      }
    };

    if (trigger === 'hover') {
      el.addEventListener('mouseenter', showHandler);
      el.addEventListener('mouseleave', hideHandler);
    } else if (trigger === 'click') {
      el.addEventListener('click', () => {
        if (tooltip.style.opacity === '1') {
          hide();
        } else {
          show();
        }
      });
      document.addEventListener('click', (e) => {
        if (!el.contains(e.target) && !tooltip.contains(e.target)) {
          hide();
        }
      });
    }

    el._tooltipEl = tooltip;
    el._tooltipShow = showHandler;
    el._tooltipHide = hideHandler;
  },

  unbind(el) {
    if (el._tooltipEl) {
      document.body.removeChild(el._tooltipEl);
    }
    el.removeEventListener('mouseenter', el._tooltipShow);
    el.removeEventListener('mouseleave', el._tooltipHide);
    clearTimeout(el._tooltipTimer);
  }
};
